// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-container {\n  max-height: calc(100vh - 60px);\n}\n.el-menu-vertical-demo:not(.el-menu--collapse) {\n  width: 240px;\n  min-height: 400px;\n}\n.el-menu-item.is-active {\n  background-color: #5895ff;\n}\n", ""]);
// Exports
module.exports = exports;
